// User-facing error messages for various error scenarios
export const ERROR_MESSAGE_GENERAL = 'Oops! There seems to be an error. Please try again.'
export const ERROR_MESSAGE_INTERNAL_SERVER =
  'An internal error occurred. The development team has been notified. If this issue persists, please contact support.'
export const ERROR_MESSAGE_SERVICE_UNAVAILABLE = 'The Workforce service appears to be temporarily unavailable. Please try again later.'
export const ERROR_MESSAGE_CLIENT_ERROR = 'The server rejected the request. Please contact support.'
export const ERROR_MESSAGE_OFFLINE = 'You appear to be offline. Please check your connection and try again.'
export const ERROR_MESSAGE_UNEXPECTED = 'An unexpected error occurred. Please try again.'
export const ERROR_MESSAGE_RATE_LIMITED =
  "The AI model's rate limit was reached. This can happen when a large file or a long conversation is sent in a single request. Please wait a moment and try again, or retry with a smaller file."

// Machine-readable error codes attached to llmError messages by the backend
// (torqagent-api classifies the provider error while it is still structured;
// see WF-2547). The persisted `content` / SSE `value` keeps the raw provider
// text for debugging.
export const LLM_ERROR_CODE_RATE_LIMITED = 'RATE_LIMITED'

// Text-matching fallback ONLY for llmError rows persisted before the backend
// started attaching errorCode (and for self-hosted backends not yet upgraded).
const RATE_LIMIT_PATTERN = /too many requests|rate.?limit|\b429\b/i

export function getFriendlyLlmErrorMessage(raw: string, errorCode?: string): string {
  if (errorCode === LLM_ERROR_CODE_RATE_LIMITED || (errorCode === undefined && RATE_LIMIT_PATTERN.test(raw))) {
    return ERROR_MESSAGE_RATE_LIMITED
  }
  return raw
}
